import { NgModule, LOCALE_ID } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CoreModule } from './core/core.module';
import { MaterialModule } from './shared/material.module';
import { AppHttpInterceptor } from './core/interceptors/app-http-interceptor';
import { registerLocaleData } from '@angular/common';
import locale from '@angular/common/locales/pt';
import { UploaderModule } from './features/uploader/download-uploader/uploader.module';
import { AuthService } from './core/services/auth.service';
import { Router } from '@angular/router';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { getPtBrPaginatorIntl } from './shared/util/ptBr-paginator-intl';
import { LoaderService } from './loader.service';
import { GoogleAnalyticsService } from './shared/services/google-analytics.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieService } from 'ngx-cookie-service';
import { FormsModule } from '@angular/forms';

// registra regionalizações em pt-BR para exibição de datas, dinheito e etc em pt-BR
registerLocaleData(locale, 'pt-BR');

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    UploaderModule,
    HttpClientModule,
    MaterialModule,
    FormsModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpClient]
        }
    }),
    ToastrModule.forRoot({
      timeOut: 10000,
      preventDuplicates: true
    }),

    CoreModule,

    // routes
    AppRoutingModule
  ],
  providers: [

    { provide: LOCALE_ID, useValue: 'pt-BR' },

    LoaderService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppHttpInterceptor,
      multi: true,
      deps: [AuthService, Router, LoaderService]

    },

    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: MatPaginatorIntl, useValue: getPtBrPaginatorIntl() },

    GoogleAnalyticsService,
    CookieService

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
